import type { Translations } from '@/types';

export const translations: Translations = {
  en: {
    // Header
    about: "About",
    services: "Services", 
    vehicleRental: "Vehicle Rental",
    contact: "Contact",
    getQuote: "Get Quote",
    
    // Hero
    heroTitle: "Leading Contracting and Trading Establishment in Jubail",
    heroSubtitle: "Comprehensive contracting and trading solutions across Saudi Arabia and GCC since 2008. From materials trading to workforce solutions, we deliver excellence in every project.",
    heroButton: "Explore Services",
    
    // About
    aboutTitle: "About Arabian Al Waha Est",
    aboutSubtitle: "Your trusted partner in contracting and trading excellence",
    aboutDescription: "Arabian Al Waha Establishment (formerly known as Gulfcoast Contracting Est) is a leading contracting and trading establishment in Jubail, Saudi Arabia, delivering exceptional solutions across the Kingdom and GCC region since 2008. With deep expertise in materials trading, equipment rentals, workforce solutions, and vehicle services, we are committed to excellence in every project.",
    aboutMission: "Our mission is to deliver exceptional value through innovative solutions, reliable service, and unwavering commitment to quality in every project we undertake.",
    
    // Services
    servicesTitle: "Our Services",
    servicesSubtitle: "Comprehensive solutions for your business needs",
    contractingTitle: "General Contracting",
    contractingDesc: "End-to-end project management and construction services with proven expertise across diverse sectors.",
    tradingTitle: "Materials Trading", 
    tradingDesc: "Premium quality construction materials and industrial supplies sourced from trusted global partners.",
    equipmentTitle: "Equipment Rental",
    equipmentDesc: "Modern, well-maintained machinery and equipment for construction, industrial, and commercial applications.",
    workforceTitle: "Workforce Solutions",
    workforceDesc: "Skilled professional teams and comprehensive human resource solutions tailored to project requirements.",
    
    // Vehicle Rental
    vehicleTitle: "Vehicle Rental Services",
    vehicleSubtitle: "Professional transportation solutions for every need",
    vehicleDescription: "Our comprehensive vehicle rental services provide reliable transportation solutions for businesses and individuals across Saudi Arabia.",
    fleetTitle: "Modern Fleet",
    fleetDesc: "Well-maintained vehicles ranging from executive cars to heavy-duty trucks and specialized equipment transporters.",
    flexibleTitle: "Flexible Terms",
    flexibleDesc: "Short-term and long-term rental options with competitive rates and comprehensive insurance coverage.",
    supportTitle: "24/7 Support",
    supportDesc: "Round-the-clock customer support and emergency assistance to ensure your operations never stop.",
    
    // Contact
    contactTitle: "Get In Touch",
    contactSubtitle: "Ready to discuss your project? Contact us today.",
    contactDescription: "Let's discuss how Arabian Al Waha Est can support your next project with our comprehensive contracting and trading services.",
    phone: "Phone",
    email: "Email",
    address: "Address",
    location: "Qatif/Dammam, Eastern Province, Saudi Arabia",
    
    // Legal Documents
    documentsTitle: "Legal Documents & Certifications",
    documentsSubtitle: "Our official business credentials and certifications",
    commercialRegTitle: "Commercial Registration",
    commercialRegDesc: "Official business registration with the Ministry of Commerce",
    vatRegTitle: "VAT Registration",
    vatRegDesc: "Value Added Tax registration certificate",
    chamberTitle: "Chamber Membership",
    chamberDesc: "Active membership in the Chamber of Commerce",
    bankDetailsTitle: "Bank Details",
    bankDetailsDesc: "Official banking information and account details",
    bankName: "Bank Name",
    accountNumber: "Account Number",
    ibanNumber: "IBAN",
    enterPinToView: "Enter PIN code to view bank details",
    unlock: "Unlock",
    invalidPin: "Invalid PIN code",
    copied: "Copied!",
    success: "Success",
    error: "Error",
    nationalAddressTitle: "National Address",
    nationalAddressDesc: "Verified business address proof",
    downloadDocument: "Download Document",
    viewDocument: "View Document",

    // Major Clients
    majorClientsTitle: "Major Client References",
    majorClientsSubtitle: "Trusted by leading companies across Saudi Arabia and the GCC",
    trustedPartner: "Trusted partner of industry leaders since 2008",
    notableProjects: "Notable Projects",
    notableProjectsSubtitle: "Proven track record of successful project delivery",
    
    // HSE Policy
    hseTitle: "Health, Safety & Environment Policy",
    hseSubtitle: "Our commitment to workplace safety and environmental responsibility",
    hseIntro: "At Arabian Al Waha Est, we are committed to maintaining the highest standards of health, safety, and environmental protection in all our operations.",
    safetyCommitment: "Safety Commitment",
    safetyText: "We prioritize the safety and well-being of our employees, contractors, and the communities in which we operate through comprehensive safety programs and continuous training.",
    environmentalPolicy: "Environmental Responsibility", 
    environmentalText: "We are dedicated to minimizing our environmental impact through sustainable practices, waste reduction, and compliance with all environmental regulations.",
    complianceTitle: "Regulatory Compliance",
    complianceText: "We ensure full compliance with all Saudi Arabian health, safety, and environmental regulations, maintaining the highest industry standards.",

    // Footer
    footerTagline: "Empowering Visions • Building Futures",
    quickLinks: "Quick Links",
    ourServices: "Our Services", 
    followUs: "Follow Us",
    allRights: "All rights reserved.",
    formerlyKnown: "Formerly known as Gulfcoast Contracting Est",
    privacyPolicy: "Privacy Policy",
    termsOfService: "Terms of Service",
    qualityStandards: "Quality Standards",
    emergencySupport: "24/7 Emergency Support",
    
    // Contact Form
    firstName: "First Name",
    lastName: "Last Name",
    emailAddress: "Email Address",
    companyName: "Company Name",
    phoneNumber: "Phone Number",
    projectRequirements: "Tell us about your project requirements...",
    sendMessage: "Send Message",
    sending: "Sending...",
    thankYouMessage: "Thank you! Your message has been sent successfully.",
    errorMessage: "There was an error sending your message. Please try again.",
    contactInformation: "Contact Information",
    contactInfoDesc: "Our team is available to discuss your project needs and provide comprehensive solutions for your operations.",
    businessHours: "Business Hours",
    businessHoursTime: "Sunday - Thursday: 8:00 AM - 6:00 PM",
    emergencyAvailable: "24/7 Emergency Support Available",
    availableEmergencies: "Available 24/7 for emergencies",
    
    // About Stats
    yearsExperience: "Years Experience",
    projectsCompleted: "Projects Completed",
    supportAvailable: "Support Available",
    
    // Service Features
    projectExecution: "Project Execution",
    buildSupport: "Build Support",
    smartMaintenance: "Smart Maintenance",
    qualityAssurance: "Quality Assurance",
    materialSupply: "Material Supply",
    qualityMaterials: "Quality Materials",
    timelyDelivery: "Timely Delivery",
    competitivePricing: "Competitive Pricing",
    extensiveFleet: "Extensive Fleet",
    topQualityGear: "Top-Quality Gear",
    rapidDelivery: "Rapid Delivery",
    flexibleTerms: "Flexible Terms",
    expertPersonnel: "Expert Personnel",
    skilledWorkers: "Skilled Workers",
    professionalSupport: "Professional Support",
    reliableService: "Reliable Service",
    
    // Vehicle Types
    heavyTrucks: "Heavy Trucks",
    heavyTrucksDesc: "Heavy-duty trucks for construction and material transport",
    constructionVehicles: "Construction Vehicles",
    constructionVehiclesDesc: "Specialized construction vehicles for all project needs",
    commercialVehicles: "Commercial Vehicles",
    commercialVehiclesDesc: "Fleet of commercial vehicles for business operations",
    specializedEquipment: "Specialized Equipment",
    specializedEquipmentDesc: "Specialized vehicles and equipment for specific requirements",
    wellMaintained: "Well-Maintained Fleet",
    maintenanceIncluded: "Maintenance Included",
    excavators: "Excavators",
    bulldozers: "Bulldozers",
    cranes: "Cranes",
    materialHandlers: "Material Handlers",
    pickupTrucks: "Pickup Trucks",
    vans: "Vans",
    suvs: "SUVs",
    sedans: "Sedans",
    customSolutions: "Custom Solutions",
    technicalSupport: "Technical Support",
    emergencyService: "Emergency Service",
  },
  ar: {
    // Header
    about: "من نحن",
    services: "خدماتنا",
    vehicleRental: "تأجير المركبات", 
    contact: "تواصل معنا",
    getQuote: "احصل على عرض سعر",
    
    // Hero
    heroTitle: "المؤسسة الرائدة للمقاولات والتجارة في الجبيل",
    heroSubtitle: "حلول شاملة للمقاولات والتجارة في جميع أنحاء المملكة العربية السعودية ودول مجلس التعاون الخليجي منذ عام 2008. من تجارة المواد إلى حلول القوى العاملة، نحن نقدم التميز في كل مشروع.",
    heroButton: "استكشف الخدمات",
    
    // About
    aboutTitle: "حول مؤسسة الواحة العربية",
    aboutSubtitle: "شريكك الموثوق في التميز في المقاولات والتجارة",
    aboutDescription: "مؤسسة الواحة العربية (المعروفة سابقاً باسم مؤسسة جلف كوست للمقاولات) هي مؤسسة رائدة في المقاولات والتجارة في الجبيل، المملكة العربية السعودية، تقدم حلولاً استثنائية في جميع أنحاء المملكة ومنطقة دول مجلس التعاون الخليجي منذ عام 2008. مع الخبرة العميقة في تجارة المواد وتأجير المعدات وحلول القوى العاملة وخدمات المركبات، نحن ملتزمون بالتميز في كل مشروع.",
    aboutMission: "مهمتنا هي تقديم قيمة استثنائية من خلال الحلول المبتكرة والخدمة الموثوقة والالتزام الثابت بالجودة في كل مشروع نتعهده.",
    
    // Services
    servicesTitle: "خدماتنا",
    servicesSubtitle: "حلول شاملة لاحتياجات عملك",
    contractingTitle: "المقاولات العامة",
    contractingDesc: "إدارة المشاريع الشاملة وخدمات البناء مع خبرة مثبتة عبر قطاعات متنوعة.",
    tradingTitle: "تجارة المواد",
    tradingDesc: "مواد البناء عالية الجودة والإمدادات الصناعية من شركاء عالميين موثوقين.",
    equipmentTitle: "تأجير المعدات",
    equipmentDesc: "آلات ومعدات حديثة وجيدة الصيانة للتطبيقات الإنشائية والصناعية والتجارية.",
    workforceTitle: "حلول القوى العاملة",
    workforceDesc: "فرق مهنية ماهرة وحلول شاملة للموارد البشرية مصممة حسب متطلبات المشروع.",
    
    // Vehicle Rental
    vehicleTitle: "خدمات تأجير المركبات",
    vehicleSubtitle: "حلول نقل احترافية لكل احتياج",
    vehicleDescription: "تقدم خدمات تأجير المركبات الشاملة لدينا حلول نقل موثوقة للشركات والأفراد في جميع أنحاء المملكة العربية السعودية.",
    fleetTitle: "أسطول حديث",
    fleetDesc: "مركبات جيدة الصيانة تتراوح من السيارات التنفيذية إلى الشاحنات الثقيلة وناقلات المعدات المتخصصة.",
    flexibleTitle: "شروط مرنة",
    flexibleDesc: "خيارات إيجار قصيرة وطويلة المدى بأسعار تنافسية وتغطية تأمينية شاملة.",
    supportTitle: "دعم على مدار الساعة",
    supportDesc: "دعم عملاء على مدار الساعة ومساعدة طارئة لضمان عدم توقف عملياتك أبداً.",
    
    // Contact
    contactTitle: "تواصل معنا",
    contactSubtitle: "مستعد لمناقشة مشروعك؟ تواصل معنا اليوم.",
    contactDescription: "دعنا نناقش كيف يمكن لمؤسسة الواحة العربية دعم مشروعك التالي بخدمات المقاولات والتجارة الشاملة لدينا.",
    phone: "الهاتف",
    email: "البريد الإلكتروني",
    address: "العنوان",
    location: "القطيف/الدمام، المنطقة الشرقية، المملكة العربية السعودية",
    
    // Legal Documents
    documentsTitle: "الوثائق القانونية والشهادات",
    documentsSubtitle: "أوراق اعتمادنا التجارية الرسمية وشهاداتنا",
    commercialRegTitle: "السجل التجاري",
    commercialRegDesc: "تسجيل الأعمال الرسمي لدى وزارة التجارة",
    vatRegTitle: "تسجيل ضريبة القيمة المضافة",
    vatRegDesc: "شهادة تسجيل ضريبة القيمة المضافة",
    chamberTitle: "عضوية الغرفة التجارية",
    chamberDesc: "عضوية فعالة في الغرفة التجارية",
    bankDetailsTitle: "البيانات المصرفية",
    bankDetailsDesc: "المعلومات المصرفية الرسمية وتفاصيل الحساب",
    bankName: "اسم البنك",
    accountNumber: "رقم الحساب",
    ibanNumber: "رقم الآيبان",
    enterPinToView: "أدخل رمز PIN لعرض التفاصيل المصرفية",
    unlock: "فتح",
    invalidPin: "رمز PIN غير صحيح",
    copied: "تم النسخ!",
    success: "نجح",
    error: "خطأ",
    nationalAddressTitle: "العنوان الوطني",
    nationalAddressDesc: "إثبات عنوان العمل المعتمد",
    downloadDocument: "تحميل الوثيقة",
    viewDocument: "عرض الوثيقة",

    // Major Clients
    majorClientsTitle: "مراجع العملاء الرئيسيين",
    majorClientsSubtitle: "موثوق به من قبل الشركات الرائدة في المملكة العربية السعودية ودول مجلس التعاون الخليجي",
    trustedPartner: "شريك موثوق لقادة الصناعة منذ عام 2008",
    notableProjects: "المشاريع البارزة",
    notableProjectsSubtitle: "سجل حافل من التنفيذ الناجح للمشاريع",

    // HSE Policy
    hseTitle: "سياسة الصحة والسلامة والبيئة",
    hseSubtitle: "التزامنا بسلامة مكان العمل والمسؤولية البيئية",
    hseIntro: "في مؤسسة الواحة العربية، نحن ملتزمون بالحفاظ على أعلى معايير الصحة والسلامة وحماية البيئة في جميع عملياتنا.",
    safetyCommitment: "التزام السلامة",
    safetyText: "نعطي الأولوية لسلامة ورفاهية موظفينا والمقاولين والمجتمعات التي نعمل فيها من خلال برامج السلامة الشاملة والتدريب المستمر.",
    environmentalPolicy: "المسؤولية البيئية",
    environmentalText: "نحن مكرسون لتقليل تأثيرنا البيئي من خلال الممارسات المستدامة وتقليل النفايات والامتثال لجميع اللوائح البيئية.",
    complianceTitle: "الامتثال التنظيمي",
    complianceText: "نحن نضمن الامتثال الكامل لجميع لوائح الصحة والسلامة والبيئة السعودية، مع الحفاظ على أعلى معايير الصناعة.",

    // Footer
    footerTagline: "تمكين الرؤى • بناء المستقبل",
    quickLinks: "روابط سريعة",
    ourServices: "خدماتنا",
    followUs: "تابعنا",
    allRights: "جميع الحقوق محفوظة.",
    formerlyKnown: "المعروفة سابقاً باسم مؤسسة جلف كوست للمقاولات",
    privacyPolicy: "سياسة الخصوصية",
    termsOfService: "شروط الخدمة",
    qualityStandards: "معايير الجودة",
    emergencySupport: "دعم طوارئ على مدار الساعة",
    
    // Contact Form
    firstName: "الاسم الأول",
    lastName: "اسم العائلة",
    emailAddress: "عنوان البريد الإلكتروني",
    companyName: "اسم الشركة",
    phoneNumber: "رقم الهاتف",
    projectRequirements: "أخبرنا عن متطلبات مشروعك...",
    sendMessage: "إرسال رسالة",
    sending: "جاري الإرسال...",
    thankYouMessage: "شكراً لك! تم إرسال رسالتك بنجاح.",
    errorMessage: "حدث خطأ أثناء إرسال رسالتك. يرجى المحاولة مرة أخرى.",
    contactInformation: "معلومات الاتصال",
    contactInfoDesc: "فريقنا متاح لمناقشة احتياجات مشروعك وتقديم حلول شاملة لعملياتك.",
    businessHours: "ساعات العمل",
    businessHoursTime: "الأحد - الخميس: 8:00 صباحاً - 6:00 مساءً",
    emergencyAvailable: "دعم الطوارئ متاح على مدار الساعة",
    availableEmergencies: "متاح على مدار الساعة للطوارئ",
    
    // About Stats
    yearsExperience: "سنوات الخبرة",
    projectsCompleted: "المشاريع المكتملة",
    supportAvailable: "الدعم المتاح",
    
    // Service Features
    projectExecution: "تنفيذ المشاريع",
    buildSupport: "دعم البناء",
    smartMaintenance: "الصيانة الذكية",
    qualityAssurance: "ضمان الجودة",
    materialSupply: "توريد المواد",
    qualityMaterials: "مواد عالية الجودة",
    timelyDelivery: "التسليم في الوقت المحدد",
    competitivePricing: "أسعار تنافسية",
    extensiveFleet: "أسطول واسع",
    topQualityGear: "معدات عالية الجودة",
    rapidDelivery: "التسليم السريع",
    flexibleTerms: "شروط مرنة",
    expertPersonnel: "موظفون خبراء",
    skilledWorkers: "عمال مهرة",
    professionalSupport: "دعم احترافي",
    reliableService: "خدمة موثوقة",
    
    // Vehicle Types
    heavyTrucks: "الشاحنات الثقيلة",
    heavyTrucksDesc: "شاحنات للخدمة الشاقة للبناء ونقل المواد",
    constructionVehicles: "مركبات البناء",
    constructionVehiclesDesc: "مركبات بناء متخصصة لجميع احتياجات المشروع",
    commercialVehicles: "المركبات التجارية",
    commercialVehiclesDesc: "أسطول من المركبات التجارية للعمليات التجارية",
    specializedEquipment: "المعدات المتخصصة",
    specializedEquipmentDesc: "مركبات ومعدات متخصصة لمتطلبات محددة",
    wellMaintained: "أسطول جيد الصيانة",
    maintenanceIncluded: "الصيانة مشمولة",
    excavators: "الحفارات",
    bulldozers: "الجرافات",
    cranes: "الرافعات",
    materialHandlers: "معالجات المواد",
    pickupTrucks: "شاحنات البيك أب",
    vans: "الشاحنات الصغيرة",
    suvs: "سيارات الدفع الرباعي",
    sedans: "السيدان",
    customSolutions: "حلول مخصصة",
    technicalSupport: "الدعم الفني",
    emergencyService: "خدمة الطوارئ",
  }
};

export type TranslationKey = keyof typeof translations.en;